(function() {
    if(document.querySelector('.c-find-ships')){
        loadJSArrayOnIntersection(".c-find-ships", ['/wp-content/themes/asbestos/assets/js/plugins/jquery.js', '/wp-content/themes/asbestos/assets/js/plugins/jquery.autocomplete.js' ,'/wp-content/themes/asbestos/assets/js/src/organisms/find-ships.js']);
    }
  })();